import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { useTracker } from '../../../context/hooks';
import { SeoRecommendations } from '../../constants';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const H1TagsKBLink = () => {
  const {
    track
  } = useTracker();
  const handleClickKBLink = event => {
    track('clickedLearnMoreLink', {
      recommendationType: SeoRecommendations.ADD_H1_TAGS,
      linkAddress: event.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsx(Link, {
    href: "https://blog.hubspot.com/marketing/header-tags",
    external: true,
    onClick: handleClickKBLink,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.linkText.ADD_H1_TAGS"
    })
  });
};
export const AddH1TagsView = ({
  auditResult
}) => {
  const {
    status
  } = auditResult;
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.ADD_H1_TAGS"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.ADD_H1_TAGS"
    }),
    status: status,
    children: /*#__PURE__*/_jsx(View, {
      marginInlineStart: "600",
      as: "div",
      children: /*#__PURE__*/_jsx(H1TagsKBLink, {})
    })
  });
};